import { GetPoolsList, GetTeachersList } from '@src/services/form'
import { GetOccupancyMap } from '@src/services/occupancy-map.js'
import { getSavedState } from '@src/utils/localStorage'

export const state = {
    poolsList: [],
    teachersList: [],
    occupancyMap: [],
}

export const getters = {}

export const mutations = {
    SET_POOLS(state, newList) {
        state.poolsList = newList
    },
    SET_TEACHERS(state, newList) {
        state.teachersList = newList
    },
    SET_OCCUPANCY_MAP(state, newList) {
        state.occupancyMap = newList
    },
    REMOVE_PREVIOUS_MAP(state) {
        state.occupancyMap = []
    },
}

export const actions = {
    async fetchPoolsList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetPoolsList({ locationPublicId, parameters })
        if (resp.status === 200) {
            commit('SET_POOLS', resp.data.data.items)
        }
        return resp
    },

    async fetchTeachersList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetTeachersList({ locationPublicId, parameters })
        if (resp.status === 200) {
            commit('SET_TEACHERS', resp.data.data.items)
        }
        return resp
    },
    async fetchOccupancyMap({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetOccupancyMap({ locationPublicId, parameters })
        if (resp.status === 200) {
            commit('REMOVE_PREVIOUS_MAP')
            commit('SET_OCCUPANCY_MAP', resp.data.data)
        }
        return resp
    },
}
